import {Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from "@angular/core";
import {ModalService} from "../../services/modal.service";
import {Subject} from "rxjs/Subject";
import {APP_MESSAGES, DOCUMENT_TYPES} from "../../enums/enums";
import {NvFileUploader} from "../../classes/nv-file-uploader/nv-file-uploader.class";
import {AnimationsService, IAnimationInfo} from "../../services/animations.service";
import {ErrorService} from "../../services/error.service";
import {FileItem, FileLikeObject} from "ng2-file-upload";
import {IDocument} from "../../interfaces/document.definition";
import {PreloaderService} from "../../services/preloader.service";
import {paramsHelper} from "../../helpers/params-helper";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {CollectionService} from "../../services/collection.service";
import {NvSelect2Component} from "../../components/nv-select/nv-select2.component";
import {DocumentService} from "../../services/document.service";

import * as validateSpine from "../../../../../util/spine-validator/validator.js";

declare const $: any;


@Component({
  selector: 'nv-spine-modal',
  templateUrl: './nv-spine-modal.component.html',
  styles: []
})
export class NvSpineModalComponent implements OnInit, OnDestroy {
  @ViewChildren(NvSelect2Component) selects: QueryList<NvSelect2Component>;
  @ViewChild("modalRoot") element: ElementRef;

  private unsubscribe: Subject<void> = new Subject<void>();
  private _document: IDocument;
  private animationInfo: IAnimationInfo;
  loadedAtlases: IDocument[] = [];

  hasBaseDropZoneOver: boolean = false;
  uploader = new NvFileUploader({
    url: "/animations/upload",
    removeAfterUpload: true,
    filters:[ { name: "filename-filter", fn: (file: FileLikeObject):boolean => {
      const filename = file ? file.name : "";
      return /\.png$/i.test(filename) || /\.json$/i.test(filename) || /\.skel$/i.test(filename);
    }}]
  });

  constructor(private modalService: ModalService,
              private animationsService: AnimationsService,
              private errorService: ErrorService,
              private collectionService: CollectionService,
              private documentService:DocumentService,
              private preloaderService:PreloaderService) {
  }

  ngOnInit() {
    this.modalService
      .onModalRequest
      .takeUntil(this.unsubscribe)
      .filter(
        appMessage => appMessage.type === APP_MESSAGES.POPUP_SPINE_EDITOR_MODAL)
      .subscribe(
        appMessage => this.show(<IDocument>appMessage.content));

    this.uploader.onCompleteAll = () => {
      this.onUploadComplete();
    }

    this.uploader
      .onError
      .subscribe((response: string): void => this.onUploadError(response));

    this.loadAtlasesList();
  }

  onAtlasChanged() {
    this.animationsService
      .updateDestinationAtlas("animation","" + this._document.id, this._document._type, null, this.animationInfo.atlas)
      .subscribe(() => {});
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  onUploadAllClick() {
    this.preloaderService.show();
    var readQueue = [];
    for (let file of this.uploader.queue)
    {
      readQueue.push(this.readFile(file.file));
    }

    Promise.all(readQueue)
      .then(results => {
        var errors:Array<String> = validateSpine.Validator.validate(results, this._document['category'], this._document);
        this.preloaderService.hide();
        if (errors.length == 0)
        {
          this.animationsService
            .clearContent("animation","" + this._document.id, this._document._type, null)
            .subscribe(() => {
              this.preloaderService.show();
              this.uploader.options.headers = [
                {name: "ownerId", value: "" + this._document.id},
                {name: "ownerType", value: this._document._type},
                {name: "type", value: "animation"}//no underscore in headers
              ];
              this.uploader.uploadAll();
            });
        }
        else {
          this.modalService.showWarning(`Ошибки: ${errors.toString()}`);
        }
      });
  }
  
  onUploadAndPackClick() {
      this.onUploadAllClick();
  }

  private readFile(file:FileLikeObject):Promise<any> {
      return new Promise<any>((resolve) => {
        let reader:FileReader = new FileReader();
        reader.onloadend = function (e) {
          let ext:string = file.name.split(".")[1];
          if (ext == "skel")
          {
            return resolve({fileName: file.name, content: btoa(reader.result)});
          }
          else
          {
            return resolve({fileName: file.name, content: reader.result});
          }

        }

        reader.readAsBinaryString(new Blob([file.rawFile]));
      });
  }

  onClearQueueClick() {
    this.uploader.clearQueue();
  }

  onRemoveAssetsClick() {
    this.animationsService
      .clearContent("animation", "" + this._document.id, this._document._type, null)
      .subscribe(()=>this.loadAnimationInfo());
  }

  onPackClick() {
    this.packGOAssets();
  }

  private loadAtlasesList() {
    const params = paramsHelper
      .loader()
      .setEndpointId(E_ENDPOINTS.API)
      .setObjectType(DOCUMENT_TYPES.ATLAS)
      .setNavParams(0, 9999);

    this.collectionService.loadChunkCached(params)
      .subscribe(r => {
        this.loadedAtlases = r.documents;
        this.updateAtlasesSelects();
      })
  }

  private updateAtlasesSelects() {

    if (!this.selects) {
      return;
    }
    this.selects
      .forEach((select: NvSelect2Component): void => select.setItems(this.loadedAtlases));
  }

  private show(document: IDocument) {
    this._document = document;
    $(this.element.nativeElement).modal();
    this.loadAnimationInfo();

  }

  private loadAnimationInfo() {
    this.animationsService
      .loadInfo("animation", this._document.id.toString(), this._document._type, null)
      .subscribe(
        a => {
          this.animationInfo = a;
        });
  }

  private packGOAssets() {
    this.animationsService.runPacker().subscribe(() => {this.animationsService.startPackerStatusUpdate()});
  }

  private onUploadComplete() {
    this.preloaderService.hide();
    this.loadAnimationInfo();
    // join upload and packing processes
    this.packGOAssets();
  }

  private onUploadError(response: string) {
    this.errorService.handleError(new Error(`Upload error: ${response}`));
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/modals/nv-spine-modal/nv-spine-modal.component.ts